export const WILLOW_HOME = 'https://willow.tech';
export const WILLOW_GITHUB = 'https://github.com/willow-network';
export const WILLOW_X = 'https://x.com/willow_protocol';
export const WILLOW_DISCORD = 'https://discord.gg/BrrA56x24f';
export const BLOCKCHAIN_EXPLORER_URL = 'https://explorer.willow.tech';
